import classnames from "classnames"
import "./PathStepDetails.css"

import Avatar from "@pathwright/ui/src/components/avatar/Avatar"
import Button from "@pathwright/ui/src/components/button/Button"
import Link from "@pathwright/ui/src/components/link/Link"
import { useTranslate } from "@pathwright/ui/src/components/lng/withTranslate"
import Pathicon from "@pathwright/ui/src/components/pathicon/Pathicon"
import { useUIThemeContext } from "@pathwright/ui/src/components/ui/PathwrightUI"
import { useScreensizeContext } from "@pathwright/ui/src/components/ui/Screensize"
import PathDue from "@pathwright/web/src/modules/path/ui/PathDue"
import {
  getPathItemNonPassiveFutureStartsDate,
  getStepVerbIcon
} from "@pathwright/web/src/modules/path/utils"
import { usePathwrightContext } from "@pathwright/web/src/modules/pathwright/PathwrightContext"
import { LEARN, TEACH } from "path/constants"
import PathStepMeta from "./PathStepMeta"

const PathStepDetails = function ({
  item,
  mode,
  path,
  status,
  analytics,
  standalone,
  children
}) {
  const screensize = useScreensizeContext()
  const theme = useUIThemeContext()
  const { me } = usePathwrightContext()
  const { t, i18n } = useTranslate()
  const group = path ? path.items.find((i) => i.id === item.parent_id) : null

  // TODO: fix this to never happen
  if (!item.step_verb) return null

  const tPath = `path.step_types.${item.assignment_type}.verb`
  const verbTExists = i18n.exists(tPath)

  const isNext = mode === LEARN && status === "next"

  const showAction =
    isNext &&
    !standalone &&
    screensize !== "sm" &&
    !getPathItemNonPassiveFutureStartsDate(item, group)

  const colorStyle = {
    color: isNext ? theme.primaryBrandColor : null
  }

  const className = classnames("PathStepDetails", {
    [`PathStepDetails--${status}`]: status != null && !standalone,
    [`PathStepDetails--actionable`]: showAction
  })

  return (
    <div className={className}>
      {!standalone && <Link className="PathStepDetails__Link" to={item.url} />}
      <div className="PathStepDetails__Icon">
        {isNext ? (
          <Avatar user={me} size="30px" />
        ) : (
          <Pathicon icon={getStepVerbIcon(item.step_verb)} />
        )}
      </div>
      <div className="PathStepDetails__Info">
        <div className="PathStepDetails__Label">
          {mode !== TEACH && (
            <span className="PathStepDetails__Verb" style={colorStyle}>
              {verbTExists ? t(tPath) : item.step_verb}
              {`:`}
            </span>
          )}
          <h4 className="PathStepDetails__Title" style={colorStyle}>
            {item.name}
          </h4>
        </div>
        <PathStepMeta
          item={item}
          mode={mode}
          status={status}
          analytics={analytics}
        />
      </div>
      {showAction && (
        <div className="PathStepDetails__Action">
          <Button styleType="primary" size="large" to={item.url} brand>
            {t("step.start")}
          </Button>
        </div>
      )}
      {children}
      {mode === LEARN && (
        <PathDue className="PathStepDetails__PathDue" pathItem={item} />
      )}
    </div>
  )
}

PathStepDetails.displayName = "PathStepDetails"

export default PathStepDetails
